// ==============================================================================
// Story 003: The Robot Teacher (Final 6-Page Version)
// Level: 1 (Middle School Year 1)
// Target: ~6 sentences per page, High Density
// ==============================================================================

const STORY_DATA = [
  {
    title: "Part 1: The Silver Teacher",
    rubyText: [
      { w: "We", r: "ウィ" },
      { w: "have", r: "ハブ" },
      { w: "a", r: "ア" },
      { w: "new", r: "ニュー" },
      { w: "teacher", r: "ティーチャー", s: true },
      { w: "today.", r: "トゥデイ", s: true },
      { w: "His", r: "ヒズ" },
      { w: "name", r: "ネイム" },
      { w: "is", r: "イズ", s: true },
      { w: "Mr.", r: "ミスター" },
      { w: "Roboto.", r: "ロボト" , s: true},
      { w: "He", r: "ヒー" },
      { w: "is", r: "イズ" },
      { w: "not", r: "ノット", s: true },
      { w: "a", r: "ア" },
      { w: "human.", r: "ヒューマン" , s: true},
      { w: "He", r: "ヒー" },
      { w: "is", r: "イズ" },
      { w: "a", r: "ア" },
      { w: "robot", r: "ロボット", s: true },
      { w: "from", r: "フロム" },
      { w: "the", r: "ザ" },
      { w: "future.", r: "フューチャー" , s: true},
      { w: "His", r: "ヒズ" },
      { w: "body", r: "ボディ" },
      { w: "is", r: "イズ" },
      { w: "silver", r: "シルバー", s: true },
      { w: "and", r: "アンド" },
      { w: "shiny.", r: "シャイニー", s: true },
      { w: "He", r: "ヒー" },
      { w: "stands", r: "スタンズ", s: true },
      { w: "at", r: "アット" },
      { w: "the", r: "ザ" },
      { w: "front", r: "フロント", s: true },
      { w: "of", r: "オブ" },
      { w: "the", r: "ザ" },
      { w: "classroom.", r: "クラスルーム" , s: true},
    ],
    en: "We have a new teacher today. His name is Mr. Roboto. He is not a human. He is a robot from the future. His body is silver and shiny. He stands at the front of the classroom.",
    ja: "今日、新しい先生がやってきました。名前はロボト先生。彼は人間ではありません。未来から来たロボットです。体は銀色でピカピカです。彼は教室の前に立っています。",
    learning: {
      vocab: [
        { word: "future", mean: "未来" },
        { word: "human", mean: "人間" },
        { word: "shiny", mean: "輝いている" },
      ],
      grammar: {
        title: "Be動詞の否定文",
        desc: "「～ではない」と言うときは、be動詞の後ろに not を置きます (He is not ...)。",
        key: "He is not a human.",
      },
    },
    color: "bg-slate-200",
    accent: "text-slate-600",
    mood: { rate: 1.0, pitch: 0.9 },
    image: "images/003/01.jpg",
    startTime: 0,
  },
  {
    title: "Part 2: Zero Seconds",
    rubyText: [
      { w: "Mr.", r: "ミスター" },
      { w: "Roboto", r: "ロボト" },
      { w: "is", r: "イズ" },
      { w: "perfect", r: "パーフェクト", s: true },
      { w: "at", r: "アット" },
      { w: "everything.", r: "エブリシング", s: true },
      { w: "He", r: "ヒー" },
      { w: "teaches", r: "ティーチズ" },
      { w: "math,", r: "マス", s: true },
      { w: "science,", r: "サイエンス", s: true },
      { w: "and", r: "アンド" },
      { w: "history.", r: "ヒストリー" , s: true},
      { w: "He", r: "ヒー" },
      { w: "calculates", r: "カルキュレイツ" },
      { w: "numbers", r: "ナンバーズ", s: true },
      { w: "very", r: "ベリー" },
      { w: "fast.", r: "ファスト" , s: true},
      { w: "'123", r: "ワンツー スリー" },
      { w: "plus", r: "プラス" },
      { w: "456?'", r: "フォーファイブ シックス" , s: true},
      { w: "He", r: "ヒー" },
      { w: "answers,", r: "アンサーズ", s: true },
      { w: "'579.'", r: "ファイブセブン ナイン" , s: true},
      { w: "Zero", r: "ゼロ" },
      { w: "seconds.", r: "セカンズ" , s: true},
      { w: "He", r: "ヒー" },
      { w: "never", r: "ネバー" },
      { w: "makes", r: "メイクス", s: true },
      { w: "mistakes.", r: "ミステイクス" , s: true},
    ],
    en: "Mr. Roboto is perfect at everything. He teaches math, science, and history. He calculates numbers very fast. '123 plus 456?' He answers, '579.' Zero seconds. He never makes mistakes.",
    ja: "ロボト先生は全てにおいて完璧です。数学、理科、歴史を教えます。彼は数字をとても速く計算します。「123 + 456は？」彼は答えます。「579」。0秒です。彼は決して間違いをしません。",
    learning: {
      vocab: [
        { word: "perfect", mean: "完璧な" },
        { word: "calculate", mean: "計算する" },
        { word: "mistake", mean: "間違い" },
      ],
      grammar: {
        title: "三単現のS",
        desc: "主語がHeなので、動詞にsがつきます (calculate → calculates)。",
        key: "He calculates numbers very fast.",
      },
    },
    color: "bg-blue-100",
    accent: "text-blue-600",
    mood: { rate: 1.1, pitch: 1.0 },
    image: "images/003/02.jpg",
    startTime: 20,
  },
  {
    title: "Part 3: Too Serious",
    rubyText: [
      { w: "However,", r: "ハウエバー", s: true },
      { w: "our", r: "アワー" },
      { w: "teacher", r: "ティーチャー", s: true },
      { w: "is", r: "イズ" },
      { w: "too", r: "トゥー" },
      { w: "serious.", r: "シリアス" , s: true},
      { w: "He", r: "ヒー" },
      { w: "does", r: "ダズ" },
      { w: "not", r: "ノット" },
      { w: "smile", r: "スマイル", s: true },
      { w: "or", r: "オア" },
      { w: "laugh.", r: "ラフ", s: true },
      { w: "He", r: "ヒー" },
      { w: "says,", r: "セイズ", s: true },
      { w: "'Open", r: "オープン" },
      { w: "your", r: "ユア" },
      { w: "books", r: "ブックス", s: true },
      { w: "now.", r: "ナウ" , s: true},
      { w: "Do", r: "ドゥ" },
      { w: "not", r: "ノット" },
      { w: "talk", r: "トーク", s: true },
      { w: "to", r: "トゥ" },
      { w: "your", r: "ユア" },
      { w: "friends.", r: "フレンズ" , s: true},
      { w: "Do", r: "ドゥ" },
      { w: "not", r: "ノット" },
      { w: "sleep", r: "スリープ", s: true },
      { w: "in", r: "イン" },
      { w: "my", r: "マイ" },
      { w: "class.'", r: "クラス" , s: true},
      { w: "The", r: "ザ" },
      { w: "students", r: "スチューデンツ" },
      { w: "are", r: "アー", s: true },
      { w: "very", r: "ベリー" },
      { w: "nervous.", r: "ナーバス" , s: true},
    ],
    en: "However, our teacher is too serious. He does not smile or laugh. He says, 'Open your books now. Do not talk to your friends. Do not sleep in my class.' The students are very nervous.",
    ja: "しかし、私たちの先生は真面目すぎます。微笑みも笑いもしません。彼は言います。「今すぐ本を開きなさい。友達と話してはいけません。私の授業中に寝てはいけません」生徒たちはとても緊張しています。",
    learning: {
      vocab: [
        { word: "serious", mean: "真面目な" },
        { word: "nervous", mean: "緊張している" },
        { word: "laugh", mean: "笑う" },
      ],
      grammar: {
        title: "命令文と禁止",
        desc: "Do not (Don't) で「～してはいけない」という禁止を表します。",
        key: "Do not talk to your friends.",
      },
    },
    color: "bg-gray-100",
    accent: "text-gray-600",
    mood: { rate: 0.9, pitch: 0.8 },
    image: "images/003/03.jpg",
    startTime: 40,
  },
  {
    title: "Part 4: Ken's Question",
    rubyText: [
      { w: "One", r: "ワン" },
      { w: "student,", r: "スチューデント", s: true },
      { w: "Ken,", r: "ケン", s: true },
      { w: "raises", r: "レイズィズ" },
      { w: "his", r: "ヒズ" },
      { w: "hand", r: "ハンド", s: true },
      { w: "slowly.", r: "スローリー" , s: true},
      { w: "Ken", r: "ケン" },
      { w: "likes", r: "ライクス" },
      { w: "funny", r: "ファニー" },
      { w: "jokes", r: "ジョークス", s: true },
      { w: "very", r: "ベリー" },
      { w: "much.", r: "マッチ" , s: true},
      { w: "He", r: "ヒー" },
      { w: "wants", r: "ウォンツ" },
      { w: "to", r: "トゥ" },
      { w: "test", r: "テスト", s: true },
      { w: "the", r: "ザ" },
      { w: "robot", r: "ロボット" },
      { w: "teacher.", r: "ティーチャー" , s: true},
      { w: "The", r: "ザ" },
      { w: "class", r: "クラス" },
      { w: "becomes", r: "ビカムズ", s: true },
      { w: "very", r: "ベリー" },
      { w: "quiet.", r: "クワイエット" , s: true},
      { w: "Ken", r: "ケン" },
      { w: "asks,", r: "アスクス", s: true },
      { w: "'Mr.", r: "ミスター" },
      { w: "Roboto,", r: "ロボト", s: true },
      { w: "why", r: "ホワイ" },
      { w: "was", r: "ワズ", s: true },
      { w: "the", r: "ザ" },
      { w: "math", r: "マス" },
      { w: "book", r: "ブック", s: true },
      { w: "sad?'", r: "サッド" , s: true},
    ],
    en: "One student, Ken, raises his hand slowly. Ken likes funny jokes very much. He wants to test the robot teacher. The class becomes very quiet. Ken asks, 'Mr. Roboto, why was the math book sad?'",
    ja: "ある生徒、ケンがゆっくりと手を挙げました。ケンは面白い冗談が大好きです。彼はロボット先生を試したくなりました。教室はとても静かになります。ケンは聞きます。「ロボト先生、どうして数学の本は悲しかったのでしょうか？」",
    learning: {
      vocab: [
        { word: "raise", mean: "上げる" },
        { word: "joke", mean: "冗談" },
        { word: "test", mean: "試す" },
      ],
      grammar: {
        title: "Why ...?",
        desc: "理由を尋ねる疑問文です。「なぜ～でしたか？」と過去形で聞いています。",
        key: "Why was the math book sad?",
      },
    },
    color: "bg-orange-100",
    accent: "text-orange-600",
    mood: { rate: 1.0, pitch: 1.0 },
    image: "images/003/04.jpg",
    startTime: 60,
  },
  {
    title: "Part 5: Logical Thinking",
    rubyText: [
      { w: "Mr.", r: "ミスター" },
      { w: "Roboto", r: "ロボト" },
      { w: "stops", r: "ストップス" },
      { w: "moving", r: "ムービング", s: true },
      { w: "suddenly.", r: "サドゥンリー" , s: true},
      { w: "His", r: "ヒズ" },
      { w: "camera", r: "カメラ" },
      { w: "eyes", r: "アイズ", s: true },
      { w: "zoom", r: "ズーム" },
      { w: "in", r: "イン", s: true },
      { w: "on", r: "オン" },
      { w: "Ken.", r: "ケン" , s: true},
      { w: "He", r: "ヒー" },
      { w: "thinks", r: "シンクス" },
      { w: "hard", r: "ハード", s: true },
      { w: "about", r: "アバウト" },
      { w: "the", r: "ザ" },
      { w: "question.", r: "クエスチョン" , s: true},
      { w: "Finally,", r: "ファイナリー", s: true },
      { w: "he", r: "ヒー" },
      { w: "says,", r: "セイズ", s: true },
      { w: "'That", r: "ザット" },
      { w: "is", r: "イズ" },
      { w: "impossible.", r: "インポッシブル" , s: true},
      { w: "Books", r: "ブックス" },
      { w: "are", r: "アー" },
      { w: "made", r: "メイド", s: true },
      { w: "of", r: "オブ" },
      { w: "paper.", r: "ペイパー" , s: true},
      { w: "They", r: "ゼイ" },
      { w: "do", r: "ドゥ" },
      { w: "not", r: "ノット" },
      { w: "have", r: "ハブ", s: true },
      { w: "hearts.", r: "ハーツ" , s: true},
      { w: "So,", r: "ソー", s: true },
      { w: "they", r: "ゼイ" },
      { w: "cannot", r: "キャノット" },
      { w: "be", r: "ビー", s: true },
      { w: "sad.'", r: "サッド" , s: true},
    ],
    en: "Mr. Roboto stops moving suddenly. His camera eyes zoom in on Ken. He thinks hard about the question. Finally, he says, 'That is impossible. Books are made of paper. They do not have hearts. So, they cannot be sad.'",
    ja: "ロボト先生は突然動きを止めました。カメラの目がケンをズームします。彼は質問について一生懸命考えます。ついに、彼は言いました。「それは不可能です。本は紙でできています。心はありません。だから、悲しくなるはずがありません」",
    learning: {
      vocab: [
        { word: "suddenly", mean: "突然" },
        { word: "impossible", mean: "不可能な" },
        { word: "finally", mean: "ついに" },
      ],
      grammar: {
        title: "be made of",
        desc: "「～（材料）でできている」という表現です。",
        key: "Books are made of paper.",
      },
    },
    color: "bg-indigo-100",
    accent: "text-indigo-600",
    mood: { rate: 1.0, pitch: 0.9 },
    image: "images/003/05.jpg",
    startTime: 80,
  },
  {
    title: "Part 6: System Error",
    rubyText: [
      { w: "Ken", r: "ケン" },
      { w: "smiles", r: "スマイルズ", s: true },
      { w: "and", r: "アンド" },
      { w: "says,", r: "セイズ", s: true },
      { w: "'Because", r: "ビコーズ" },
      { w: "it", r: "イット" },
      { w: "had", r: "ハド", s: true },
      { w: "too", r: "トゥー" },
      { w: "many", r: "メニー" },
      { w: "problems!'", r: "プロブレムズ" , s: true},
      { w: "Mr.", r: "ミスター" },
      { w: "Roboto", r: "ロボト" },
      { w: "freezes.", r: "フリーゼズ" , s: true},
      { w: "'Problems?", r: "プロブレムズ" , s: true},
      { w: "Math", r: "マス" },
      { w: "problems?", r: "プロブレムズ" , s: true},
      { w: "Life", r: "ライフ" },
      { w: "problems?", r: "プロブレムズ" , s: true},
      { w: "Error!", r: "エラー" , s: true},
      { w: "Error!'", r: "エラー" , s: true},
      { w: "The", r: "ザ" },
      { w: "students", r: "スチューデンツ" },
      { w: "laugh,", r: "ラフ", s: true },
      { w: "and", r: "アンド" },
      { w: "we", r: "ウィ" },
      { w: "like", r: "ライク" },
      { w: "him", r: "ヒム", s: true },
      { w: "now.", r: "ナウ" , s: true},
    ],
    en: "Ken smiles and says, 'Because it had too many problems!' Mr. Roboto freezes. 'Problems? Math problems? Life problems? Error! Error!' The students laugh, and we like him now.",
    ja: "ケンはニヤリとして言いました。「だって、問題（悩み）がたくさんありすぎるからさ！」ロボト先生はフリーズしました。「問題？ 数学の問題？ 人生の問題？ エラー！エラー！」生徒たちは笑い、私たちは今、彼が好きになりました。",
    learning: {
      vocab: [
        { word: "because", mean: "なぜなら" },
        { word: "problem", mean: "問題" },
        { word: "freeze", mean: "凍りつく（固まる）" },
      ],
      grammar: {
        title: "Problemの多義語",
        desc: "Problemには「数学の計算問題」と「人生の悩み」の2つの意味があります。これがジョークのオチです。",
        key: "too many problems",
      },
    },
    color: "bg-red-50",
    accent: "text-red-600",
    mood: { rate: 1.0, pitch: 1.1 },
    image: "images/003/06.jpg",
    startTime: 100,
  },
];

const QUIZ_POOL = [
  {
    q: "What is Mr. Roboto?",
    options: ["A human", "A robot", "A monster"],
    a: 1,
    exp: "Part 1で「He is a robot from the future.」と明言されています。",
  },
  {
    q: "What color is Mr. Roboto?",
    options: ["Silver and shiny", "Red and rusty", "Blue and soft"],
    a: 0,
    exp: "Part 1で「His body is silver and shiny.」とあります。",
  },
  {
    q: "How fast does he calculate?",
    options: ["Very slow", "In 5 minutes", "In zero seconds"],
    a: 2,
    exp: "Part 2で「Zero seconds.」とあります。",
  },
  {
    q: "Does Mr. Roboto make mistakes?",
    options: ["Sometimes", "Never", "Always"],
    a: 1,
    exp: "Part 2で「He never makes mistakes.」とあります。",
  },
  {
    q: "What subjects does he teach?",
    options: ["Math, science, history", "Music and art", "Only math"],
    a: 0,
    exp: "Part 2で3つの科目が挙げられています。",
  },
  {
    q: "Why were the students nervous in Part 3?",
    options: [
      "The teacher was funny",
      "The teacher was too serious",
      "It was a holiday",
    ],
    a: 1,
    exp: "Part 3で「He is too serious.」「Do not talk.」などの描写があります。",
  },
  {
    q: "What is NOT allowed in class?",
    options: ["Reading books", "Talking and sleeping", "Studying"],
    a: 1,
    exp: "Part 3で「Do not talk. Do not sleep.」と禁止されています。",
  },
  {
    q: "Who raises his hand?",
    options: ["Aya", "Ken", "Tom"],
    a: 1,
    exp: "Part 4で「One student, Ken, raises his hand.」とあります。",
  },
  {
    q: "What does Ken like?",
    options: ["Math", "Cleaning", "Funny jokes"],
    a: 2,
    exp: "Part 4で「Ken likes funny jokes very much.」とあります。",
  },
  {
    q: "What was Ken's question?",
    options: [
      "Why is the sky blue?",
      "Why was the math book sad?",
      "Can you dance?",
    ],
    a: 1,
    exp: "Part 4で数学の本についてのなぞなぞを出しました。",
  },
  {
    q: "How did Mr. Roboto react to the question first?",
    options: ["He laughed", "He stopped and thought", "He danced"],
    a: 1,
    exp: "Part 5で「Mr. Roboto stops moving... He thinks hard.」とあります。",
  },
  {
    q: "Why did Mr. Roboto say 'Impossible'?",
    options: [
      "Books are paper and have no hearts",
      "He hates books",
      "He was tired",
    ],
    a: 0,
    exp: "Part 5で「本は紙で心がないから悲しくなれない」と論理的に返しました。",
  },
  {
    q: "What is the answer to Ken's riddle?",
    options: ["It lost money", "It had too many problems", "It was raining"],
    a: 1,
    exp: "Part 6のオチです。「Because it had too many problems!」",
  },
  {
    q: "What is the double meaning of 'problems'?",
    options: ["Math questions and troubles", "Big and small", "Happy and sad"],
    a: 0,
    exp: "「計算問題」と「悩み」の2つの意味がかかっています。",
  },
  {
    q: "What happened to Mr. Roboto at the end?",
    options: ["He exploded", "He froze (Error)", "He ran away"],
    a: 1,
    exp: "Part 6で「Mr. Roboto freezes. 'Error! Error!'」となりました。",
  },
  {
    q: "How did the students feel at the end?",
    options: ["They liked him", "They were scared", "They were angry"],
    a: 0,
    exp: "Part 6の最後に「we like him now.」とあります。",
  },
  {
    q: "Where does Mr. Roboto stand?",
    options: ["At the back", "At the front", "Outside"],
    a: 1,
    exp: "Part 1で「He stands at the front of the classroom.」とあります。",
  },
  {
    q: "What did Mr. Roboto say to the students?", // 質問を変更
    options: ["Open your books", "Close your eyes", "Go to sleep"],
    a: 0,
    exp: "Part 3で 'Open your books now.' と言っています。",
  },
  {
    q: "What did Mr. Roboto say to the students?",
    options: ["Open your books now", "Go home", "Play games"],
    a: 0,
    exp: "Part 3で「Open your books now.」と言っています。",
  },
  {
    q: "What did Mr. Roboto's eyes do?",
    options: ["Closed", "Zoomed in", "Turned red"],
    a: 1,
    exp: "Part 5で「His camera eyes zoom in.」とあります。",
  },
  {
    q: "Why did Ken want to ask a question?",
    options: [
      "He wanted to study",
      "He wanted to test the robot",
      "He was sad",
    ],
    a: 1,
    exp: "Part 4で「He wants to test the robot.」とあります。",
  },
];

const SCRAMBLE_POOL = [
  {
    q: "彼は未来から来たロボットです。",
    w: ["He", "is", "a", "robot", "from", "the", "future"],
    o: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    q: "彼は人間ではありません。",
    w: ["He", "is", "not", "a", "human"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "彼は教室の前に立っています。",
    w: ["He", "stands", "at", "the", "front", "of", "the", "classroom"],
    o: [0, 1, 2, 3, 4, 5, 6, 7],
  },
  {
    q: "彼は決して間違いをしません。",
    w: ["He", "never", "makes", "mistakes"],
    o: [0, 1, 2, 3],
  },
  {
    q: "彼は数字をとても速く計算します。",
    w: ["He", "calculates", "numbers", "very", "fast"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "今すぐ本を開きなさい。",
    w: ["Open", "your", "books", "now"],
    o: [0, 1, 2, 3],
  },
  {
    q: "友達と話してはいけません。",
    w: ["Do", "not", "talk", "to", "your", "friends"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "ケンは面白い冗談が好きです。",
    w: ["Ken", "likes", "funny", "jokes"],
    o: [0, 1, 2, 3],
  },
  {
    q: "彼はロボットを試したいです。",
    w: ["He", "wants", "to", "test", "the", "robot"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "なぜ数学の本は悲しかったのですか？",
    w: ["Why", "was", "the", "math", "book", "sad"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "彼は質問について一生懸命考えます。",
    w: ["He", "thinks", "hard", "about", "the", "question"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "本は紙でできています。",
    w: ["Books", "are", "made", "of", "paper"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "本は心を持っていません。",
    w: ["Books", "do", "not", "have", "hearts"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "それらは悲しくなるはずがありません。",
    w: ["They", "cannot", "be", "sad"],
    o: [0, 1, 2, 3],
  },
  {
    q: "生徒たちは笑います。",
    w: ["The", "students", "laugh"],
    o: [0, 1, 2],
  },
  {
    q: "私たちは今、彼が好きです。",
    w: ["We", "like", "him", "now"],
    o: [0, 1, 2, 3],
  },
  {
    q: "彼の体は銀色です。",
    w: ["His", "body", "is", "silver"],
    o: [0, 1, 2, 3],
  },
  {
    q: "彼は真面目すぎます。",
    w: ["He", "is", "too", "serious"],
    o: [0, 1, 2, 3],
  },
  {
    q: "ケンはゆっくり手を挙げます。",
    w: ["Ken", "raises", "his", "hand", "slowly"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "それにはたくさんの問題がありました。",
    w: ["It", "had", "too", "many", "problems"],
    o: [0, 1, 2, 3, 4],
  },
];

const FILL_IN_THE_BLANK_POOL = [
  {
    q: "He _______ a robot from the future.",
    options: ["is", "am", "are", "be"],
    a: 0,
    exp: "主語がHe（三人称単数）なのでbe動詞はisです。",
  },
  {
    q: "We _______ a new teacher today.",
    options: ["have", "has", "having", "had"],
    a: 0,
    exp: "主語がWeなのでhaveを使います。",
  },
  {
    q: "He _______ everything about math.",
    options: ["knows", "know", "knowing", "known"],
    a: 0,
    exp: "主語がHeなので、動詞に三単現のsがつきます。",
  },
  {
    q: "He _______ makes mistakes. He is perfect.",
    options: ["never", "always", "sometimes", "ever"],
    a: 0,
    exp: "「決して～ない」という意味のneverが入ります。",
  },
  {
    q: "He stands _______ the front of the classroom.",
    options: ["at", "in", "on", "to"],
    a: 0,
    exp: "「～の前で（地点）」という場合は at the front of... が自然です。",
  },
  {
    q: "_______ not talk to your friends.",
    options: ["Do", "Does", "Did", "Are"],
    a: 0,
    exp: "禁止の命令文は Do not で始めます。",
  },
  {
    q: "Ken _______ his hand.",
    options: ["raises", "raise", "rising", "raised"],
    a: 0,
    exp: "Kenは三人称単数なので、動詞にsをつけてraisesとします。",
  },
  {
    q: "He wants _______ test the robot.",
    options: ["to", "for", "at", "on"],
    a: 0,
    exp: "want to + 動詞の原形（～したい）です。",
  },
  {
    q: "_______ was the math book sad?",
    options: ["Why", "What", "Who", "Where"],
    a: 0,
    exp: "理由を尋ねているので Why を使います。",
  },
  {
    q: "Books do not _______ hearts.",
    options: ["have", "has", "had", "having"],
    a: 0,
    exp: "助動詞 do/does の後は動詞の原形 have になります。",
  },
  {
    q: "They _______ be sad. It is impossible.",
    options: ["cannot", "can", "do", "are"],
    a: 0,
    exp: "文脈から「ありえない（できない）」という意味の cannot が入ります。",
  },
  {
    q: "_______ it had too many problems!",
    options: ["Because", "So", "But", "And"],
    a: 0,
    exp: "Whyの質問に対する答えなので Because で始めます。",
  },
  {
    q: "Books are made _______ paper.",
    options: ["of", "from", "by", "in"],
    a: 0,
    exp: "「～（材料）でできている」は be made of です。",
  },
  {
    q: "The students _______ at the funny robot.",
    options: ["laugh", "laughs", "laughing", "to laugh"],
    a: 0,
    exp: "主語 The students は複数形なので、動詞は原形 laugh です。",
  },
  {
    q: "He teaches math, science, _______ history.",
    options: ["and", "or", "but", "so"],
    a: 0,
    exp: "A, B, and C の形で列挙します。",
  },
  {
    q: "He is _______ serious.",
    options: ["too", "two", "to", "toe"],
    a: 0,
    exp: "「～すぎる」という意味の too が入ります。",
  },
  {
    q: "Open _______ books.",
    options: ["your", "you", "yours", "me"],
    a: 0,
    exp: "「あなたたちの本」なので所有格の your です。",
  },
  {
    q: "Mr. Roboto stops _______.",
    options: ["moving", "move", "to move", "moved"],
    a: 0,
    exp: "stop ～ing で「～するのをやめる」という意味になります。",
  },
  {
    q: "He calculates numbers very _______.",
    options: ["fast", "fastly", "faster", "fastest"],
    a: 0,
    exp: "「速く」という副詞 fast が入ります（fastlyという語はありません）。",
  },
  {
    q: "Now we like _______.",
    options: ["him", "he", "his", "himself"],
    a: 0,
    exp: "動詞の目的語になるので目的格 him を使います。",
  },
];

export default {
  id: "kB93d6eH",
  title: "The Robot Teacher",
  level: "LEVEL 1",
  category: "Sci-Fi",
  content: STORY_DATA,
  quizzes: QUIZ_POOL,
  puzzles: SCRAMBLE_POOL,
  fills: FILL_IN_THE_BLANK_POOL,
};


